import Detail from "../Component/Detail/Detail";

const NewsDetail = () => {
    return (
        <div>
            <Detail />
        </div>
    )
}

export default NewsDetail;